export const addConsoleNotification = (notification) => ({
    type: "NOTIFICATIONS.CONSOLE.ADD",
    payload: notification,
});
